import React, { useEffect, useState, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Form } from '@unform/web';
import { toast } from 'react-toastify';
import { includes, isArray } from 'lodash';
import * as Yup from 'yup';
import PropTypes from 'prop-types';
import { Spinner } from '~/components';
import {
  Input,
  Combobox,
  DateTime,
  Autocomplete,
  Select,
  Hidden,
} from '~/components/Form';
import {
  CENTRO_CUSTO_ABASTECIMENTO,
  MOTORISTA_ABASTECIMENTO,
  LOCALIDADE_ABASTECIMENTO,
  MODULO_20_GRAUS,
  TRR_CHILE,
  CUSTOMIZACAO_RAIZEN,
  MODULO_CUSTOMIZACAO_RUMO,
} from '~/constants/modules';
import { t, can, validCharacters } from '~/helpers';
import api from '~/services/api';
import { Container } from './styles';

export default function CreateOrUpdate({
  data,
  reference,
  close,
  cancelarAcao,
}) {
  const { client } = useSelector((state) => state.user.profile);
  const modules = useSelector((state) => state.user.modules);
  const clienteRumo = modules.includes(MODULO_CUSTOMIZACAO_RUMO);
  const [posto, setPosto] = useState(0);
  const [motorista, setMotorista] = useState(null);
  const [totalizador, setTotalizador] = useState(0);
  const [custo, setCusto] = useState(null);

  const { internounidatausuario, formaidfrentistaabast } = useSelector(
    (state) => state.user.configs
  );

  const [controla20graus, setControla20graus] = useState(0);
  const [operabastecimento20posto, setOperabastecimento20posto] = useState(0);

  const [loading, setLoading] = useState(true);
  const [initials, setInitials] = useState(null);
  const [idatendimento, setIdatendimento] = React.useState(null);
  const [
    idatendimentoabastecimento,
    setIdatendimentoabastecimento,
  ] = React.useState(null);
  const [idposto, setIdposto] = React.useState(null);
  const [antifurtoabastecimento, setAntifurtoabastecimento] = React.useState(
    null
  );
  const [chipabastecimento, setChipabastecimento] = React.useState(null);
  const [visorabastecimento, setVisorabastecimento] = React.useState(null);
  const [observacaoabastecimento, setObservacaoabastecimento] = React.useState(
    null
  );
  const [idmovimentacao, setIdmovimentacao] = React.useState(null);
  const [carregou, setCarregou] = React.useState(false);

  const optionsOk = useMemo(
    () => [
      { value: 'S', label: t('s.geral.opcoes.ok') },
      { value: 'N', label: t('s.geral.opcoes.nok') },
    ],
    []
  );

  const cellsUser = useMemo(
    () => [
      {
        id: 'codigousuario',
        label: t('s.cadastro.usuario.codigousuario'),
        filter: { type: 'text' },
      },
      {
        id: 'nomeusuario',
        label: t('s.cadastro.usuario.nomeusuario'),
        filter: { type: 'text' },
      },
    ],
    []
  );

  const [idusuario, setIdusuario] = React.useState(null);
  const [codigousuarioRegistro, setCodigousuarioRegistro] = React.useState(
    null
  );
  const isEditingUser = Boolean(initials?.idatendimentoabastecimento);

  useEffect(() => {
    if (initials) {
      setPosto(initials.idposto);
      // setControla20graus(value.controla20grausposto);
      // setOperabastecimento20posto(value.operabastecimento20posto);
      setTotalizador(Number(initials.tipototalizadorveiculo));
    }
  }, [initials]);

  useEffect(() => {
    if (carregou) {
      if (initials) {
        const updatedInitials = {
          ...(initials || {}),
          campo_antifurtoabastecimento: antifurtoabastecimento,
          campo_chipabastecimento: chipabastecimento,
          campo_visorabastecimento: visorabastecimento,
        };
        setInitials(updatedInitials);
        setCarregou(false);
      }
    }
  }, [carregou]);

  useEffect(() => {
    async function handleCarregaMovimentacaoAtendimento(
      idmovimentacao,
      idatendimento,
      idposto
    ) {
      try {
        const { data } = idmovimentacao
          ? await api.get(
              `pitstop/abastecimento/movimentacao/${idmovimentacao}/${idposto}/${idatendimento}`
            )
          : await api.get(`pitstop/abastecimento/${idatendimento}/${idposto}`);
        setIdmovimentacao(idmovimentacao);
        setIdatendimento(idatendimento); // data.idatendimento
        setIdusuario(data.idusuario);
        setCodigousuarioRegistro(data.codigousuario);
        setInitials(data);
      } catch (err) {
        // erro quando datas incompativeis
        if (err && isArray(err)) {
          toast.error(err[0]);
          await close();
        }
      }
    }
    if (data != null) {
      handleCarregaMovimentacaoAtendimento(
        data.idmovimentacao,
        data.idatendimento,
        data.idposto
      );
    }
  }, [data]);

  useEffect(() => {
    async function handleCarregaAbastecimento(idatendimento) {
      const { data } = await api.get(`/pitstop/abastecimento/${idatendimento}`);
      setIdatendimentoabastecimento(data.idatendimentoabastecimento);
      setIdposto(data.idposto);
      setAntifurtoabastecimento(data.antifurtoabastecimento);
      setChipabastecimento(data.chipabastecimento);
      setVisorabastecimento(data.visorabastecimento);
      setObservacaoabastecimento(data.observacaoabastecimento);

      setIdusuario(data.idusuario);
      setCodigousuarioRegistro(data.codigousuario);

      setCarregou(true);
      setLoading(false);
    }
    if (idatendimento) {
      handleCarregaAbastecimento(idatendimento);
    }
  }, [idatendimento]);

  async function handleCloseModal() {
    await this.setState({ open: false });
  }

  async function hancleCancelarAcao() {
    await this.setState((prevState) => ({
      ...prevState,
    }));
  }

  const valorSelecionado = (campo) => {
    const elemento = document.getElementById(campo);
    if (!elemento) {
      return null;
    }
    const valor = elemento.innerText;
    if (valor === undefined || valor === '') {
      return null;
    } else {
      const option = optionsOk.find((item) => item.label === valor);
      return option ? option.value : null;
    }
  };

  function selectItemByValue(selectId, value) {
    if (value) {
      const selectElement = document.getElementById(selectId);
      if (selectElement) {
        for (let option of selectElement.options) {
          if (option.value === value) {
            option.selected = true;
            break;
          }
        }
      }
    }
  }

  async function handleSubmit(param) {
    try {
      // rumo - verifica campos adicionais
      if (clienteRumo) {
        const schema = Yup.object().shape({
          campo_antifurtoabastecimento: Yup.string()
            .required(t('s.geral.validacao.campoobrigatorio'))
            .typeError(t('s.geral.validacao.campoobrigatorio')),
          campo_chipabastecimento: Yup.string()
            .required(t('s.geral.validacao.campoobrigatorio'))
            .typeError(t('s.geral.validacao.campoobrigatorio')),
          campo_visorabastecimento: Yup.string()
            .required(t('s.geral.validacao.campoobrigatorio'))
            .typeError(t('s.geral.validacao.campoobrigatorio')),
          observacaoabastecimento: Yup.string()
            .ensure()
            .nullable()
            .trim()
            .max(500, t('s.geral.validacao.tamanhomaximo').replace('%s', 500))
            .test(
              'characters-invalid',
              t('s.configuracao.geral.naopodecontercaracterespecial'),
              function (value) {
                return validCharacters(value);
              }
            ),
        });

        await schema.validate(param, {
          abortEarly: false,
        });
      } else {
        const schema = Yup.object().shape({
          observacaoabastecimento: Yup.string()
            .ensure()
            .nullable()
            .trim()
            .max(500, t('s.geral.validacao.tamanhomaximo').replace('%s', 500))
            .test(
              'characters-invalid',
              t('s.configuracao.geral.naopodecontercaracterespecial'),
              function (value) {
                return validCharacters(value);
              }
            ),
        });

        await schema.validate(param, {
          abortEarly: false,
        });
      }

      const objSend = {
        idatendimentoabastecimento: idatendimentoabastecimento,
        idatendimento: idatendimento,
        idcliente: client,
        idposto: param.idposto,
        antifurtoabastecimento: valorSelecionado(
          'campo_antifurtoabastecimento'
        ),
        chipabastecimento: valorSelecionado('campo_chipabastecimento'),
        visorabastecimento: valorSelecionado('campo_visorabastecimento'),
        idmovimentacao: idmovimentacao,
        atendeuatendimentoabastecimento: 'S',
        idusuarioresponsavelabastecimento:
          param?.idusuario !== undefined ? param.idusuario : idusuario,
        codigousuario:
          param?.codigousuario !== undefined
            ? param.codigousuario
            : codigousuarioRegistro,
        observacaoabastecimento: param.observacaoabastecimento,
      };

      await api.put('pitstop/abastecimento', objSend);
      await close();
      toast.success(t('s.geral.sucessoalteracao'));
    } catch (err) {
      if (err && isArray(err)) {
        toast.error(err[0]);
      }
      await cancelarAcao();
      const validationErrors = {};
      if (err instanceof Yup.ValidationError) {
        err.inner.forEach((error) => {
          validationErrors[error.path] = error.message.replace(
            `${error.path} `,
            ''
          );
        });
        reference.current.setErrors(validationErrors);
      }
    }
  }

  return (
    <>
      {loading ? (
        <div style={{ height: '14rem', width: '50rem' }}>
          <Spinner loading />
        </div>
      ) : (
        <>
          {/* {JSON.stringify(initials)} */}
          <Form ref={reference} initialData={initials} onSubmit={handleSubmit}>
            <Container>
              <Autocomplete
                name="idposto"
                disabled
                disableClearable={true}
                label="codigonomeposto"
                url="postoscomboios"
                unique="idposto"
                title={t('s.menu.configuracao.posto')}
              />

              <Combobox
                name="idbico"
                disabled
                label="bicoprodutobico"
                url="bicos"
                unique="idbico"
                title={t('s.menu.configuracao.bico')}
                hiddens={[{ name: 'idterminal' }, { name: 'idproduto' }]}
                params={{
                  wherefield: ['idposto', 'tipoproduto'],
                  valuewherefield: [posto.idposto, 'C'],
                  typewherefield: ['EQUALS', 'EQUALS'],
                  fieldlist: 'idbico, idterminal, idproduto, bicoprodutobico',
                }}
              />

              <DateTime
                time
                name="datahorainicialmovimentacao"
                disabled
                label={t(
                  's.operacao.abastecimento.datahorainicialmovimentacao'
                )}
              />

              <DateTime
                time
                name="datahorafinalmovimentacao"
                disabled
                label={t('s.operacao.abastecimento.datahorafinalmovimentacao')}
                style={{ marginTop: 16 }}
              />

              <Input
                name="idveiculo"
                disabled
                label={
                  !can(TRR_CHILE)
                    ? t('s.operacao.abastecimento.idveiculo')
                    : t('s.cadastro.codigoempresacliente')
                }
                style={{ marginTop: 16 }}
              />

              <Autocomplete
                name="idempresaveiculo"
                label={
                  can(CUSTOMIZACAO_RAIZEN)
                    ? 'idempresaveiculo'
                    : 'nomeempresaveiculo'
                }
                url="empresasveiculos"
                unique="idempresaveiculo"
                title={t('s.cadastro.veiculo.idempresaveiculo')}
                disabled={true}
              />

              {can(CENTRO_CUSTO_ABASTECIMENTO) && (
                <Input
                  name="idcentrocusto"
                  disabled
                  label={t('s.operacao.abastecimento.idcentrocusto')}
                  value={custo}
                />
              )}

              {can(LOCALIDADE_ABASTECIMENTO) && (
                <Autocomplete
                  name="idlocalidade"
                  label="nomelocalidade"
                  url="localidades"
                  unique="idlocalidade"
                  title="Localidade"
                  disabled={true}
                />
              )}

              <Input
                name="totalizadormovimentacaoabastecimento"
                type="number"
                disabled
                label={t(
                  `s.operacao.abastecimento.${
                    totalizador === 1 ? 'horimetro' : 'hodometro'
                  }`
                )}
                style={{
                  display: includes([1, 2], totalizador) ? 'block' : 'none',
                }}
              />

              <Input
                name="encerranteinicialmovimentacao"
                disabled
                label={t(
                  's.operacao.abastecimento.encerranteinicialmovimentacao'
                )}
                type="number"
              />

              <Input
                name="encerrantefinalmovimentacao"
                disabled
                label={t(
                  's.operacao.abastecimento.encerrantefinalmovimentacao'
                )}
                type="number"
              />

              <Input
                name="volumemovimentacao"
                disabled
                label={t('s.operacao.abastecimento.volumemovimentacao')}
                type="number"
              />

              {formaidfrentistaabast !== 0 && (
                <Autocomplete
                  name="codigousuario"
                  label="nomecodigousuario"
                  unique="codigousuario"
                  title={t('s.operacao.abastecimento.codigousuario')}
                  url="usuarios"
                  disableClearable={true}
                  hiddens={[{ name: 'idusuario' }]}
                  params={{
                    filterusrposto: idposto,
                    edicao: isEditingUser,
                  }}
                  disabled={Boolean(
                    initials?.idusuario || initials?.codigousuario
                  )}
                />
              )}

              {can(MOTORISTA_ABASTECIMENTO) && (
                <Input
                  name="idmotorista"
                  disabled
                  label={t('s.operacao.abastecimento.idmotorista')}
                  value={motorista}
                />
              )}

              {can(MODULO_20_GRAUS) &&
                controla20graus === 1 &&
                operabastecimento20posto === 1 && (
                  <>
                    <Input
                      name="temperaturamediamovimentacao"
                      type="number"
                      disabled
                      label={t('s.operacao.abastecimento.temperaturamedia')}
                    />
                    <Input
                      name="densidade20movimentacao"
                      type="number"
                      disabled
                      label={t('s.operacao.abastecimento.densidade20')}
                    />
                    <Input
                      name="volume20movimentacao"
                      type="number"
                      disabled
                      label={t('s.operacao.abastecimento.volume20movimentacao')}
                    />
                  </>
                )}

              {can(MODULO_CUSTOMIZACAO_RUMO) && (
                <>
                  <Select
                    name="campo_antifurtoabastecimento"
                    id="campo_antifurtoabastecimento"
                    label={t('s.cadastro.pitstop.antifurtoabastecimento')}
                    options={optionsOk}
                    defaultValue={antifurtoabastecimento}
                    style={{ marginTop: 8 }}
                    getValue={(value) => setAntifurtoabastecimento(value)}
                  />
                  <Select
                    name="campo_chipabastecimento"
                    id="campo_chipabastecimento"
                    label={t('s.cadastro.pitstop.chipabastecimento')}
                    options={optionsOk}
                    defaultValue={chipabastecimento}
                    style={{ marginTop: 12 }}
                    getValue={(value) => setChipabastecimento(value)}
                  />
                  <Select
                    name="campo_visorabastecimento"
                    id="campo_visorabastecimento"
                    label={t('s.cadastro.pitstop.visorabastecimento')}
                    options={optionsOk}
                    defaultValue={visorabastecimento}
                    style={{ marginTop: 12 }}
                    getValue={(value) => setVisorabastecimento(value)}
                  />
                </>
              )}

              <Input
                name="observacaoabastecimento"
                label={t('s.cadastro.pitstop.observacaoatendimento')}
                defaultValue={observacaoabastecimento}
                multiline
                rows={3}
                inputProps={{ maxLength: 500 }}
                style={{ marginTop: 12 }}
              />
              <Hidden name="idatendimento" devaultValue={idatendimento} />
              <Hidden name="idusuario" devaultValue={idusuario} />
              <Hidden
                name="codigousuarioRegistro"
                devaultValue={codigousuarioRegistro}
              />
              <Hidden
                name="idatendimentoabastecimento"
                devaultValue={idatendimentoabastecimento}
              />
            </Container>
          </Form>
        </>
      )}
    </>
  );
}

CreateOrUpdate.propTypes = {
  reference: PropTypes.objectOf(PropTypes.any).isRequired,
  data: PropTypes.objectOf(PropTypes.any),
};

CreateOrUpdate.defaultProps = {
  data: {},
};
